
import { Vue, Component, Prop } from "vue-property-decorator";
import { formatDate, formatDateWithTime } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import StockAdjustmentModule from "@/store/modules/barcodeSystem/stockAdjustment";
import { EditStockAdjustment  } from "@/models/api/barcodeSystem/stockAdjustments/edit";
import notifications from "@/lib/notifications";
import { ApplyStockAdjustmentRequest } from "@/models/api/barcodeSystem/stockAdjustments/apply";

const stockAdjustmentModuleState = getModule(StockAdjustmentModule);

@Component
export default class StockAdjustmentHeader extends Vue {
  @Prop({default: null})
  editStockAdjustment: EditStockAdjustment;

  showApplyAdjustmentModal: boolean = false;
  applyLoading: boolean = false;
  deleteLoading: boolean = false;
  showDeleteStockAdjustmentPrompt: boolean = false;
  
  promptForApplyStockAdjustment()
  {
    this.showApplyAdjustmentModal=true;
  }  
  
  promptForDeleteStockAdjustment()
  {
    this.showDeleteStockAdjustmentPrompt = true;
  }

  closeModals()
  {
    this.showApplyAdjustmentModal=false;
    this.showDeleteStockAdjustmentPrompt = false;
  }

  async applyAdjustment() {
    this.applyLoading = true;
    try {
      await stockAdjustmentModuleState.applyStockAdjustment(
        { id: this.editStockAdjustment.id } as ApplyStockAdjustmentRequest
      );
      notifications.success("Stock Adjustment Applied", "Stock Adjustment successfully applied.");
      this.$emit("reload");
      this.closeModals();
    } catch (ex) {
      notifications.error("Applying Stock Adjustment", "Failed to apply stock adjustment", ex);
    } finally {
      this.applyLoading = false;
    }
  }
  
  async deleteStockAdjustment() {
    this.deleteLoading = true;
    try {
      await stockAdjustmentModuleState.deleteStockAdjustment(
        this.editStockAdjustment.id
      );
      notifications.success("Stock Adjustment Deleted", "Stock Adjustment successfully deleted.");
    } catch (ex) {
      notifications.error("Deleting Stock Adjustment", "Failed to delete stock adjustment", ex);
    } finally {
      this.deleteLoading = false;
    }
  }

  get createdDate() {
    return this.editStockAdjustment ? this.formatDateWithTime(this.editStockAdjustment.createdDate) : "";
  }

  set createdDate(val){

  }

  get appliedDate() {
    return this.editStockAdjustment ? this.formatDateWithTime(this.editStockAdjustment.appliedDate) : "";
  }

  set appliedDate(val){
    
  }
  
  formatDate(val){
    return formatDate(val);
  }
  formatDateWithTime(val){
    return formatDateWithTime(val);
  }
}

